import React, { useEffect, useState } from 'react';
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { Link } from "react-router-dom";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import FooterBlue from '../../components/FooterBlue';
import HeaderBlue from '../../components/HeaderBlue';
const Home = () => {
    const navigate = useNavigate();
    const [packages, setPackages] = useState([]);

    useEffect(() => {
        axios
            .get('https://api.fleetycdl.com/api/packages/active/latest-two')
            .then((res) => {
                setPackages(res.data);
            })
            .catch((err) => console.error('Failed to fetch packages:', err));
    }, []);


    const colors = ['#555', '#c90f0fff'];

    return (
        <>

            <HeaderBlue />

            {/* Hero Section */}
            <div className="relative w-full h-screen mx-auto overflow-hidden z-40">
                <div className="slide relative w-full h-full ">
                    <video autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover z-0 ">
                        <source src="./assets/indexvideo.webm" type="video/webm" />
                        Your browser does not support the video tag.
                    </video>

                    <div className="relative top-28 md:top-6 inset-0 z-10 flex justify-center flex-col px-8 md:px-20 md:h-screen">
                        <div className="text-left font-bold text-white staffx text-6xl leading-tight lg:text-7xl">
                            CONNECTING <br />
                            <span className="b900 staffx">CARRIERS</span> <br />
                            WITH QUALIFIED<br />
                            <span className="b900 staffx">DRIVERS</span>
                        </div>
                        <p className="text-white text-xl mt-6">
                            Drivers at Your Fingertips — Flat fees, No Markups.
                        </p>
                        <div className="flex gap-5 mt-5">
                            <Link
                                to="/carrier-registration"
                                className="bg-blue-600 text-white text-xl px-7 py-3 rounded-md hover:bg-white hover:text-blue-600 transition-all"
                            >
                                Get Started
                            </Link>

                            <a href="#learnmore" className="text-white text-xl px-7 py-3 rounded-md hover:bg-white hover:text-blue-600 transition-all">
                                Learn more
                            </a>
                        </div>
                    </div>
                    <div className="absolute inset-0 bg-black bg-opacity-50 z-5"></div>
                </div>
            </div>

            {/* How It Works Section */}
            <section
                className="bg-gray-50 md:py-20 px-4 sm:px-8 lg:px-24 md:h-screen"
                style={{
                    background: "url('./assets/BENBGsmall.webp')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
                id="learnmore"
            >
                <div className="max-w-7xl mx-auto text-center">
                    <h2
                        className="section-titlelEFT leading-tight text-gray-800 staffx"
                        style={{
                            fontSize: 50,
                            textAlign: 'left',
                            textDecorationThickness: '3px',
                            marginBottom: '14px',
                        }}
                    >
                        How It Works
                    </h2>

                    <div className="font-semibold interfont text-left mb-6">
                        Our platform helps you connect directly with verified truckers, no middlemen, no hassle. <br />
                        Simplify your logistics, reduce costs, and manage your transport operations with ease.
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                        {/* Step 1 */}
                        <div className="bg-white shadow-xl rounded-2xl p-4 hover:shadow-2xl transition duration-300 group zoomeffect">
                            <div className="mx-auto w-40 mb-2 flex items-center justify-center bg-indigo-100 text-indigo-600 text-2xl rounded-full font-bold group-hover:bg-indigo-600 group-hover:text-white transition">
                                <img src="assets/icons/SUBSCRIBEICONsmall.webp" alt="Subscribe" />
                            </div>
                            <h3 className="text-xl font-semibold text-gray-800 mb-2 staffx group-hover:text-blue-500">
                                Subscribe to Our Platform
                            </h3>
                            <p className="text-gray-600 text-sm font-semibold interfont">
                                Join us to unlock access to a large network of reliable truckers across the region.
                            </p>
                        </div>

                        {/* Step 2 */}
                        <div className="bg-white shadow-xl rounded-2xl p-4 hover:shadow-2xl transition duration-300 group zoomeffect">
                            <div className="mx-auto w-40 mb-2 flex items-center justify-center bg-indigo-100 text-indigo-600 text-2xl rounded-full font-bold group-hover:bg-indigo-600 group-hover:text-white transition">
                                <img src="assets/icons/vettedtrucker.webp" alt="Vetted Truckers" />
                            </div>
                            <h3 className="text-xl font-semibold text-gray-800 mb-2 staffx group-hover:text-blue-500">
                                Receive Qualified Truckers</h3>
                            <p className="text-gray-600 text-sm font-semibold interfont">
                                We provide verified truckers based on your business needs, saving you time and risk.
                            </p>
                        </div>
                        {/* Step 3 */}
                        <div className="bg-white shadow-xl rounded-2xl p-4 hover:shadow-2xl transition duration-300 group zoomeffect">
                            <div className="mx-auto w-40 mb-2 flex items-center justify-center bg-indigo-100 text-indigo-600 text-2xl rounded-full font-bold group-hover:bg-indigo-600 group-hover:text-white transition">
                                <img src="assets/review.jpg" alt="Review" />
                            </div>
                            <h3 className="text-xl font-semibold text-gray-800 mb-2 staffx group-hover:text-blue-500">
                                Review & Contact</h3>
                            <p className="text-gray-600 text-sm font-semibold interfont">
                                View profiles, compare, and connect with truckers directly, no middlemen involved.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Operations Section */}
            <section
                className="md:h-screen md:flex md:justify-center bg-cover py-10 md:p-0 h-60"
                style={{ backgroundImage: "url('./assets/icons/roadsmall.webp')" }}
            >
                <div className="md:w-4/5 mx-auto md:mt-12">
                    <h2
                        className="font-semibold md:mt-20 text-white text-right -mb-2 text-shadow staffx text-xl md:text-5xl mr-4"
                        style={{ textShadow: "0 0 11px black" }}
                    >
                        SIMPLIFY YOUR OPERATIONS. AMPLIFY YOUR PROFIT.
                    </h2>
                    <img src="assets/truckred.webp" alt="Truck" />
                </div>
                <div className="justify-center text-center relative md:-60 mb-40 mt-10"></div>
            </section>
            <div className="bg-gray-300">
                <p className="p-4 md:hidden text-lg">
                    Tired of complex logistics slowing you down? Our advanced trucking solutions are designed to streamline your day-to-day,
                    making your business run smoother and more efficiently.
                    Spend less time on headaches and more time focusing on what matters: increasing your earnings and growing your business.
                </p>
            </div>

            {/* Carrier Package Section */}
            <section
                className="p-5 md:pr-40 md:pl-20 md:pt-20 md:pb-10 relative"
                style={{
                    background: "url('./assets/graybg.webp')",
                    backgroundSize: "cover",
                }}
            >
                <div className="md:flex justify-center items-center">
                    <div className="md:w-2/5 mx-auto md:mr-20 md:pl-20">
                        <h2 className="section-titlelEFT leading-tight text-gray-800" style={{ fontSize: 40 }}>
                            Carrier Package for <br />
                            <span className="font-semibold">STRATEGIC GROWTH</span>
                        </h2><br />
                        <div className="font-semibold interfont text-left mb-6 xl:text-lg">
                            Stop searching and start connecting with the best in the business. Our tailored
                            carrier packages provide the ultimate platform to efficiently identify, attract,
                            and hire top-tier drivers who will propel your team forward.
                        </div>
                        <Link
                            to="/pricing"
                            className="bg-blue-600 text-white text-lg px-5 py-2 rounded-md hover:bg-white hover:text-blue-500 transition-all"
                        >
                            Explore our Packages
                        </Link>

                        <img src="assets/packageimg.png" className="mt-5" alt="Package" />
                    </div>
                    <div
                        className={`z-10 mt-10 flex-1 ${packages.length === 1
                            ? 'flex justify-center'
                            : 'grid md:grid-cols-2 gap-4'
                            }`}
                    >
                        {packages.map((pkg, index) => (
                            <div
                                key={pkg._id}
                                className="pricing-card col-span-1"
                                style={{
                                    borderRadius: '10px',
                                    overflow: 'hidden',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                    backgroundColor: '#f9f9f9',
                                    fontFamily: 'sans-serif',
                                }}
                            >
                                <div
                                    className="pricing-header"
                                    style={{
                                        backgroundColor: colors[index] || '#555',
                                        color: '#fff',
                                        padding: '30px 20px',
                                        position: 'relative',
                                        clipPath: 'polygon(0 0, 100% 0, 100% 80%, 50% 100%, 0 80%)',
                                        textAlign: 'center',
                                    }}
                                >
                                    <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '10px' }}>
                                        {pkg.name}
                                    </h2>
                                    <p className="price" style={{ fontSize: '2rem', fontWeight: '700', margin: '0' }}>
                                        ${pkg.price}
                                    </p>
                                    {/* <Link to="/pricing"> */}
                                    <button onClick={() => navigate(`/package-details/${pkg._id}`)}
                                        className="buy-btn"
                                        style={{
                                            marginTop: '20px',
                                            backgroundColor: '#000',
                                            color: '#fff',
                                            border: 'none',
                                            padding: '10px 20px',
                                            borderRadius: '5px',
                                            cursor: 'pointer',
                                            fontWeight: '600',
                                        }}
                                    >
                                        Select package
                                    </button>
                                    {/* </Link> */}
                                </div>
                                <h3
                                    style={{
                                        fontSize: '1rem',
                                        fontWeight: '600',
                                        padding: '0 20px',
                                        marginTop: '10px',
                                        marginBottom: '5px',
                                        color: '#333',
                                        fontFamily: 'sans-serif',
                                    }}
                                >
                                    Package Benefits
                                </h3>

                                <ul
                                    className="features"
                                    style={{
                                        listStyle: 'none',
                                        padding: '20px',
                                        margin: '0',
                                        color: '#333',
                                        fontSize: '0.95rem',
                                        lineHeight: '1.8',
                                    }}
                                >
                                    {pkg.features.map((feat, i) => (
                                        <li key={i}>
                                            <i className="fas fa-check-circle text-green-500 mr-2"></i> {feat}
                                        </li>
                                    ))}
                                </ul>

                            </div>
                        ))}

                        <div className="col-span-2 mt-10"></div>
                    </div>
                </div>
            </section>
            {/* Dashboard Section */}
            <section
                className="md:px-20 md:py-20 md:flex bg-white bg-cover"
                style={{
                    backgroundImage: "url('./assets/24867small.webp')",
                    backgroundPosition: "0px 70px",
                    backgroundSize: "cover",
                }}
            >
                <img src="assets/moc-img.png" className="h-auto mx-auto md:w-2/3 mt-5" style={{ height: "fit-content" }} alt="iPad Mockup" />
                <div className="pt-5 bg-white md:bg-transparent">
                    <h2 className="section-titlelEFT leading-tight text-gray-800 scale-90 md:scale-100 mt-20" style={{ fontSize: 40 }}>
                        Drive Smarter, Earn More <br />
                        <span className="font-semibold" style={{ fontSize: 40 }}>ADVANCED DASHBOARD</span>
                    </h2><br />
                    <div className="mx-auto text-lg font-semibold interfont -mt-5 px-5 md:px-0">
                        It's time to elevate your trucking business.
                        This powerful tool seamlessly builds your professional network,
                        monitors key business metrics, and unlocks new levels of profitability.
                    </div>
                </div>
            </section>

            {/* Newsletter Section */}
            <section
                className="p-5 md:px-40 md:py-32 md:grid grid-cols-3 bg-cover"
                style={{ backgroundImage: "url('./assets/newsleterimgsmall.webp')" }}
            >
                <div className="col-span-2 text-white spacing-10">
                    <h2 className="font-bold text-2xl">Sign up for FLEETY NEWSLETTER</h2>
                    <p>
                        Stay up to date on truck driving industry news and see the
                        latest trucking updates<br /> from trucking companies looking for drivers.
                    </p>
                    <form className="my-4">
                        <input type="email" placeholder="Enter Your Email" className="p-2 rounded" />
                        <button type="submit" className="text-white px-5">Sign Up!</button>
                    </form>
                    <div>
                        <p>
                            I agree to receive emails from Fleety.com. I understand that I can
                            unsubscribe at any time.
                        </p>
                        <p className="text-white">
                            By clicking on "Sign Up", you agree to our <a href="#" className="text-blue-500">Terms of Use</a>
                        </p>
                    </div>
                </div>
            </section>

            {/* Our Clients Section */}
            <section className="py-16 px-4 sm:px-6 lg:px-8">
                <div className="max-w-7xl mx-auto">
                    <div className="text-center mb-12">
                        <h2 className="section-title font-bold text-gray-900">
                            Trusted by INDUSTRY LEADERS <b>WORLDWIDE </b>
                        </h2>
                    </div>
                    <div className="relative">
                        <button id="prevBtn" className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 focus:outline-none">
                            <i className="fas fa-chevron-left text-gray-700"></i>
                        </button>
                        <button id="nextBtn" className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 focus:outline-none">
                            <i className="fas fa-chevron-right text-gray-700"></i>
                        </button>
                        <div id="logoSlider" className="overflow-hidden">
                            <div className="flex transition-transform duration-300 ease-in-out">
                                {Array.from({ length: 14 }).map((_, i) => (
                                    <img
                                        key={i}
                                        src={`./assets/client${i % 2 + 1}.png`}
                                        alt={`Client ${i % 2 + 1}`}
                                        className="w-40 h-24 object-contain mx-4"
                                    />
                                ))}
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            {/* Contact Section */}
            <section
                className="bg-gray-50 py-20 px-4 sm:px-8 lg:px-24"
                style={{ background: "url(assets/15158small.webp)", backgroundSize: "cover" }}
            >
                <div className="max-w-7xl mx-auto">
                    <h2 className="leading-tight text-center text-white staffx" style={{ fontSize: 40 }}>
                        Contact & Support
                    </h2><br />
                    <h2 className="section-title"></h2>
                    <p className="text-white text-center mb-9 text-xl -mt-6">
                        We’re here to help. Whether you're a company or trucker, reach out with any questions.
                    </p>
                    <div className="grid grid-cols-1 md:grid-cols-2 mx-auto">
                        {/* Contact Form */}
                        <form className="bg-white p-4 shadow-xl rounded-2xl space-y-4">
                            <h3 className="text-xl">Please fill the form below to get in touch with us.</h3>
                            <div>
                                <label className="block text-gray-700 font-medium mb-2" htmlFor="name">Name</label>
                                <input type="text" id="name" name="name" placeholder="Your name" className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                            </div>
                            <div>
                                <label className="block text-gray-700 font-medium mb-2" htmlFor="email">Email</label>
                                <input type="email" id="email" name="email" placeholder="you@example.com" className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                            </div>
                            <div>
                                <label className="block text-gray-700 font-medium mb-2" htmlFor="message">Message</label>
                                <textarea id="message" name="message" rows="2" placeholder="How can we help you?" className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-indigo-500"></textarea>
                            </div>
                            <button type="submit" className="w-full bg-blue-600 text-white font-semibold py-3 rounded-lg hover:bg-black transition">Send Message</button>
                        </form>
                        {/* Contact Info */}
                        <div className="flex flex-col justify-center space-y-6 text-white">
                            <div className="flex flex-col gap-12 p-20 bg-black bg-opacity-70 md:w-3/4 md:rounded-r-2xl rounded-b-2xl">
                                <div className="text-lg">
                                    <h3 className="font-semibold text-xl mb-2">Phone Support</h3>
                                    <p><strong>📞</strong> +1 (246) 400-0505</p>
                                    <p className="text-white text-sm">Available 9 AM – 6 PM (Mon–Sat)</p>
                                </div>
                                <div className="text-lg">
                                    <h3 className="font-semibold text-xl mb-2">Email Support</h3>
                                    <p><strong>✉️</strong> support@fleety.com</p>
                                    <p className="text-white text-sm">We typically respond within 24 hours.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <FooterBlue />
        </>
    )
};

export default Home;
